import { createFileRoute } from '@tanstack/react-router'
import AuthScreen from './-components'
import SelectAccess from './-components'

export const Route = createFileRoute('/(auth)/select-access/')({
  component: () => <SelectAccess />
})